import { BroadcastProfilesInterface } from './BroadcastProfile';
import { Location } from './venue';

export type Beacon = {
  beacon_id: string;
  beacon_type: string;
  broadcast_profiles: BroadcastProfilesInterface;
  notes: string;
  import_info: {
    import_timestamp: string;
    source: string;
    order_id: string;
  } | null;
  assigned_asset?: {
    id: string;
    name: string;
    asset_type: {
      id: string;
      name: string;
      is_enabled: true;
    };
  }

  location?: Location;
  mobility_state?: string;
  last_location_update_timestamp?: string;
  last_update_timestamp?: string;
  battery?: number;
};

export type UnregisteredBeacon = {
  _version: number;
  beacon_id: string;
  beacon_type: string;
  broadcast_profiles: BroadcastProfilesInterface;
  notes: string;
  source: string;
  order_id: string;
  tags: [];
  manager_id: string;
};

export type BeaconListResponse = {
  items: Beacon[]
  next: string
  total: number
}

export type UnregesterdBeaconListResponse = {
  items: UnregisteredBeacon[]
  next: string
  total: number
}

export class BeaconDto {
  data: Beacon = {
    beacon_id: "",
    beacon_type: "",
    import_info: null,
    notes: "",
    broadcast_profiles: {
      eddystone_uid: null,
      ibeacon: null
    }
  }
  revision: number = 0
}